<script>
import axios from '@/utils/axios';

export default {
  inject: ['setLoading'],
  emits: ['updated'],
  data() {
    return {
      data: [],
      pagination: {
        current_page: 1,
        per_page: 25,
        last_page: 1,
        total: 0,
        links: []
      },
      remarkModal: {
        show: false,
        type: '',
        challan: null,
        remark: '',
        document: null,
        documentName: '',
        submitting: false,
      },
    };
  },

//   mounted() {
//     this.loadPendingItems();
//   },

  methods: {
openRemarkModal(type, challan) {
 
  this.$closeModal('pending_items_modal');

  this.remarkModal = {
    show: true,
    type: type,
    challan: challan,
    remark: '',
    document: null,
    documentName: '',
    submitting: false,
  };
},

closeRemarkModal() {
  this.remarkModal = {
    show: false,
    type: '',
    challan: null,
    remark: '',
    document: null,
    documentName: '',
    submitting: false,
  };

  this.$openModal('pending_items_modal');
},
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.remarkModal.document = file;
        this.remarkModal.documentName = file.name;
      }
    },

    removeFile() {
      this.remarkModal.document = null;
      this.remarkModal.documentName = '';
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },

    async submitRemarkModal() {
  if (!this.remarkModal.remark.trim()) {
    this.$swalToast('Please enter a remark.', 'error');
    return;
  }

  const challan = this.remarkModal.challan;
  const type = this.remarkModal.type;
  const dc_item_ids = challan.challan_items.map(item => item.id);

  const formData = new FormData();
  dc_item_ids.forEach(id => formData.append('dc_item_ids[]', id));
  formData.append('remark', this.remarkModal.remark.trim());
  if (this.remarkModal.document) {
    formData.append('document', this.remarkModal.document);
  }

  const endpoint = type === 'approve'
    ? `/inventory/delivery-challans/${challan.id}/items/approve`
    : `/inventory/delivery-challans/${challan.id}/items/reject`;

  this.remarkModal.submitting = true;
  try {
    const response = await axios.post(endpoint, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    this.$swalToast(response.data.message);
    this.closeRemarkModal();
    this.loadPendingItems(this.pagination.current_page);
    this.$emit('updated');
  } catch (error) {
    this.$swalToast(error.message, 'error');
  } finally {
    this.remarkModal.submitting = false;
  }
},



    async loadPendingItems(page = 1) {
      this.setLoading(true);
      try {
        const response = await axios.get(`/inventory/delivery-challans/pending-items?page=${page}`);
        this.data = response.data.data.data;
        this.pagination = {
          current_page: response.data.data.current_page,
          per_page: response.data.data.per_page,
          last_page: response.data.data.last_page,
          total: response.data.data.total,
          links: response.data.data.links
        };
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },

approveItems(challan) {
  this.openRemarkModal('approve', challan);
},

rejectItems(challan) {
  this.openRemarkModal('reject', challan);
},

    changePage(url) {
      if (!url) return;
      const page = new URL(url).searchParams.get('page');
      this.loadPendingItems(page);
    },

    formatDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    formatCurrency(val) {
      return parseFloat(val || 0).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
    },

    recipientName(row) {
      if (row.recipient_type === 'App\\Models\\Customer') {
        return row.recipient?.company_name || row.recipient?.name || '-';
      }
      if (row.recipient_type === 'App\\Models\\WorkOrder') {
        return row.recipient?.name || '-';
      }
      return row.recipient?.user?.name || row.recipient_details?.name || '-';
    },
  },
};
</script>

<template>
  <div class="modal fade" id="pending_items_modal" tabindex="-1">
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

        <div class="modal-header" style="background:#f8f9fb;border-bottom:1px solid #f0f1f5;padding:16px 20px;">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;background:#fff8e1;border-radius:8px;">
              <i class="ti ti-clock" style="font-size:17px;color:#f59e0b;"></i>
            </span>
            <div>
              <h5 class="modal-title fw-bold mb-0">Exceed Work Order budget</h5>
              <span class="text-muted fs-12">Challans waiting for approval</span>
            </div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body" style="padding:16px;background:#fff;">

          <div v-if="data.length">
            <div v-for="challan in data" :key="challan.id"
              style="border:1px solid #e8eaf0;border-radius:10px;margin-bottom:16px;overflow:hidden;">

              <!-- Challan Header -->
              <div style="background:#f8f9fb;padding:12px 16px;border-bottom:1px solid #e8eaf0;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;">
                <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">
                  <span style="font-size:14px;font-weight:700;color:#1a1d23;">{{ challan.challan_number }}</span>
                  <span class="badge bg-warning-subtle text-warning rounded-pill">Partial Pending</span>
                  <span style="font-size:12px;color:#9e9e9e;">
                    <i class="ti ti-user me-1"></i>{{ recipientName(challan) }}
                  </span>
                  <span style="font-size:12px;color:#9e9e9e;">
                    <i class="ti ti-building-warehouse me-1"></i>{{ challan.warehouse?.name || '-' }}
                  </span>
                  <span style="font-size:12px;color:#9e9e9e;">
                    <i class="ti ti-calendar me-1"></i>{{ formatDate(challan.dispatch_date) }}
                  </span>
                </div>
                <div style="display:flex;gap:8px;" v-if="challan.challan_items && challan.challan_items.length">
                <button class="btn btn-sm btn-success d-flex align-items-center gap-1" @click="approveItems(challan)">
                    <i class="ti ti-check"></i> Approve
                </button>
                <button class="btn btn-sm btn-danger d-flex align-items-center gap-1" @click="rejectItems(challan)">
                    <i class="ti ti-x"></i> Reject
                </button>
                </div>
                <span v-else class="badge bg-success-subtle text-success rounded-pill">All Items Processed</span>
              </div>

              <!-- Items -->
              <div style="padding:12px 16px;" v-if="challan.challan_items && challan.challan_items.length">
                <table class="table table-sm mb-0" style="font-size:13px;">
                  <thead>
                    <tr style="background:#f8f9fb;">
                      <th style="font-size:11px;font-weight:600;">#</th>
                      <th style="font-size:11px;font-weight:600;">Item</th>
                      <th style="font-size:11px;font-weight:600;">HSN</th>
                      <th style="font-size:11px;font-weight:600;">Qty</th>
                      <th style="font-size:11px;font-weight:600;">Unit Price</th>
                      <th style="font-size:11px;font-weight:600;">Tax</th>
                      <th style="font-size:11px;font-weight:600;">Total</th>
                      <th style="font-size:11px;font-weight:600;">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in challan.challan_items" :key="item.id">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <span style="font-weight:500;">{{ item.name }}</span>
                        <br>
                        <span class="text-muted" style="font-size:11px;">{{ item.item?.code || '' }}</span>
                      </td>
                      <td>{{ item.hsn_code || '-' }}</td>
                      <td>{{ item.quantity }}</td>
                      <td>{{ formatCurrency(item.unit_price) }}</td>
                      <td>{{ formatCurrency(item.tax_amount) }}</td>
                      <td style="font-weight:600;">{{ formatCurrency(item.total) }}</td>
                      <td>
                        <span class="badge rounded-pill"
                          :class="{
                            'bg-warning-subtle text-warning': item.status === 'pending',
                            'bg-success-subtle text-success': item.status === 'approved',
                            'bg-danger-subtle text-danger': item.status === 'rejected',
                          }">
                          {{ item.status }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- No items -->
              <div v-else style="padding:12px 16px;color:#9e9e9e;font-size:13px;">
                No items found.
              </div>

              <!-- Challan Footer Total -->
              <div  v-if="challan.challan_items && challan.challan_items.length" style="padding:10px 16px;border-top:1px solid #e8eaf0;display:flex;justify-content:flex-end;gap:20px;background:#fafafa;">
                <span style="font-size:12px;color:#9e9e9e;">Subtotal: <strong>{{ formatCurrency(challan.subtotal) }}</strong></span>
                <span style="font-size:12px;color:#9e9e9e;">Tax: <strong>{{ formatCurrency(challan.tax_amount) }}</strong></span>
                <span style="font-size:13px;color:#e84040;font-weight:700;">Total: {{ formatCurrency(challan.total) }}</span>
              </div>

            </div>
          </div>

          <!-- No Data -->
          <div v-else class="text-center py-5 text-muted">
            <i class="ti ti-check-circle fs-1 d-block mb-2 opacity-50"></i>
            <p class="mb-0">No pending items found.</p>
          </div>

          <!-- Pagination -->
          <nav v-if="pagination.links.length > 3" class="mt-3">
            <ul class="pagination pagination-sm">
              <li v-for="(link, index) in pagination.links" :key="index"
                :class="['page-item', { active: link.active, disabled: !link.url }]">
                <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
              </li>
            </ul>
          </nav>

        </div>

        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <!-- ============ Remark + Document Upload Modal ============ -->
<div class="modal fade" :class="{ show: remarkModal.show }" 
  :style="remarkModal.show ? 'display:block;z-index:1060;' : 'display:none'" tabindex="0">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

      <!-- Header -->
      <div class="modal-header" style="padding:16px 20px;border-bottom:1px solid #f0f1f5;"
        :style="remarkModal.type === 'approve' ? 'background:#f0fdf4;' : 'background:#fef2f2;'">
        <div style="display:flex;align-items:center;gap:10px;">
          <span style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:8px;"
            :style="remarkModal.type === 'approve' ? 'background:#dcfce7;' : 'background:#fee2e2;'">
            <i :class="remarkModal.type === 'approve' ? 'ti ti-check' : 'ti ti-x'"
              :style="remarkModal.type === 'approve' ? 'font-size:17px;color:#22c55e;' : 'font-size:17px;color:#e84040;'"></i>
          </span>
          <div>
            <h6 class="modal-title fw-bold mb-0">
              {{ remarkModal.type === 'approve' ? 'Approve Items' : 'Reject Items' }}
            </h6>
            <span class="text-muted" style="font-size:12px;" v-if="remarkModal.challan">
              {{ remarkModal.challan.challan_number }}
            </span>
          </div>
        </div>
        <button type="button" class="btn-close" @click="closeRemarkModal" :disabled="remarkModal.submitting"></button>
      </div>

      <!-- Body -->
      <div class="modal-body" style="padding:20px;">

        <!-- Remark -->
        <div class="mb-3">
          <label class="form-label fw-semibold" style="font-size:13px;">
            Remark <span class="text-danger">*</span>
          </label>
          <textarea class="form-control" rows="3" v-model="remarkModal.remark"
            :placeholder="remarkModal.type === 'approve' ? 'Enter approval remark...' : 'Enter rejection reason...'"
            style="font-size:13px;border-radius:8px;" :disabled="remarkModal.submitting"></textarea>
        </div>

        <!-- Document Upload -->
        <div class="mb-2">
          <label class="form-label fw-semibold" style="font-size:13px;">
            Upload Document <span class="text-danger">*</span>
          </label>

          <div v-if="!remarkModal.documentName"
            style="border:2px dashed #d1d5db;border-radius:10px;padding:24px;text-align:center;cursor:pointer;"
            @click="$refs.fileInput.click()"
            @dragover.prevent
            @drop.prevent="handleFileChange({ target: { files: $event.dataTransfer.files } })">
            <i class="ti ti-cloud-upload" style="font-size:28px;color:#9ca3af;"></i>
            <p style="margin:8px 0 0;font-size:13px;color:#6b7280;">Click to upload or drag & drop</p>
            <p style="margin:2px 0 0;font-size:11px;color:#9ca3af;">PDF, JPG, PNG (Max 5MB)</p>
          </div>

          <div v-else
            style="display:flex;align-items:center;justify-content:space-between;padding:10px 14px;border:1px solid #e5e7eb;border-radius:8px;background:#f9fafb;">
            <div style="display:flex;align-items:center;gap:8px;">
              <i class="ti ti-file-filled" style="font-size:18px;color:#6366f1;"></i>
              <span style="font-size:13px;font-weight:500;color:#374151;">{{ remarkModal.documentName }}</span>
            </div>
            <button type="button" class="btn btn-sm" style="padding:2px 6px;" @click="removeFile" :disabled="remarkModal.submitting">
              <i class="ti ti-x" style="font-size:14px;color:#e84040;"></i>
            </button>
          </div>

          <input type="file" ref="fileInput" style="display:none;" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
            @change="handleFileChange" :disabled="remarkModal.submitting">
        </div>

      </div>

      <!-- Footer -->
      <div class="modal-footer" style="padding:12px 20px;border-top:1px solid #f0f1f5;">
        <button type="button" class="btn btn-sm btn-light" @click="closeRemarkModal" :disabled="remarkModal.submitting">
          Cancel
        </button>
        <button type="button" class="btn btn-sm d-flex align-items-center gap-1"
          :class="remarkModal.type === 'approve' ? 'btn-success' : 'btn-danger'"
          @click="submitRemarkModal" :disabled="remarkModal.submitting">
          <span v-if="remarkModal.submitting" class="spinner-border spinner-border-sm"></span>
          <i v-else :class="remarkModal.type === 'approve' ? 'ti ti-check' : 'ti ti-x'"></i>
          {{ remarkModal.submitting ? 'Submitting...' : (remarkModal.type === 'approve' ? 'Approve' : 'Reject') }}
        </button>
      </div>

    </div>
  </div>
</div>
<div v-if="remarkModal.show" class="modal-backdrop fade show" 
  style="z-index:1055;" @click="closeRemarkModal"></div>
</template>